import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function CloudflarePage(): Node {
  return html`
    <div>
      <h1>Deploy to Cloudflare Pages</h1>
      <p>Cloudflare Pages serves static sites from their global edge network with built-in SPA support. Use the default <strong>path-based routing</strong>.</p>

      <h2>Quick Deploy</h2>
      <ol>
        <li>Go to the <a href="https://dash.cloudflare.com/?to=/:account/pages" target="_blank">Cloudflare Pages dashboard</a></li>
        <li>Click "Create a project" → Connect to Git</li>
        <li>Select your repository and configure:</li>
      </ol>

      <table>
        <tr><th>Setting</th><th>Value</th></tr>
        <tr><td>Build command</td><td><code>npm run build</code></td></tr>
        <tr><td>Build output directory</td><td><code>dist</code></td></tr>
      </table>

      <h2>SPA Fallback</h2>
      <p>Cloudflare Pages automatically serves <code>index.html</code> for paths that don't match a static file (404 fallback). No extra configuration is needed for SPA routing.</p>

      ${Callout('Cloudflare Pages handles SPA fallback automatically. You do not need a _redirects file or custom rules for client-side routing.')}

      <h2>Custom Headers and Redirects</h2>
      <p>If you need custom headers, create a <code>public/_headers</code> file:</p>
      ${CodeBlock(`/*
  X-Frame-Options: DENY
  X-Content-Type-Options: nosniff
  Referrer-Policy: strict-origin-when-cross-origin`, 'text')}

      <h2>Router Configuration</h2>
      ${CodeBlock(`import { Router, mount } from 'onefold';

// Path-based routing — no configureRouter needed
const app = Router([
  { path: '/', view: () => Home() },
  { path: '/dashboard', view: () => Dashboard() },
], () => NotFound());

mount(app, document.getElementById('app')!);`)}

      <h2>Deploy via Wrangler CLI</h2>
      ${CodeBlock(`# Install Wrangler
npm i -g wrangler

# Build and deploy
npm run build
wrangler pages deploy dist --project-name=my-app`, 'bash')}

      <h2>Environment Variables</h2>
      <p>Set build-time environment variables in the Cloudflare Pages dashboard under Settings → Environment variables. Use them in your build script:</p>
      ${CodeBlock(`// build.mjs
await build({
  define: {
    '__API_URL__': JSON.stringify(process.env.API_URL || '/api'),
  },
});`)}

      <h2>Next Steps</h2>
      <ul>
        <li><a href="/deployment/aws">AWS S3 + CloudFront</a> — self-managed static hosting</li>
        <li><a href="/deployment/docker">Docker / Node</a> — containerized deployment</li>
      </ul>
    </div>
  `;
}
